//预加载图片资源,新年2020对联
export default [
    require("@/assets/img/theme/new-year-2020/bg.png")
]